/* eslint-disable no-shadow */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* These rules aredisabled because these eslint rules are deprecated
		(and broken, even if you have a form control properly linked with forHTML it shows an error) */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* This is disabled because we dont want keyboard controls to drag the event viewer around */

import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { addNewRelicPageAction } from 'ddc-new-relic';
import ViewEvent from './ViewEvent';
import Settings from './Settings';
import debounce from '../utils/debounce';
import { watchArray, unwatchArray } from '../utils/watchArray';
import {
	getSettings,
	watchSettings,
	unwatchSettings,
	setSetting
} from '../utils/eventViewerSettings';
import flattenObject from '../utils/flattenObject';
import './EventViewer.scss';

const bound = (number, min, max) => Math.max(min, Math.min(max, number));

export default function EventViewer(props) {
	const [settings, setSettingsState] = useState(getSettings());

	const {
		showing,
		cmsWebAsSource,
		filters,
		left,
		top,
		width,
		height,
		fullscreen,
		additionalSources,
		promptUnload,
		order: orderSetting
	} = settings;
	useEffect(() => {
		const settingsChangeHandler = (newSettings) => {
			setSettingsState(newSettings);
		};
		watchSettings(settingsChangeHandler);
		return function cleanup() {
			unwatchSettings(settingsChangeHandler);
		};
	});

	const [settingsOpen, setSettingsOpen] = useState(false);
	const [additionalSourcesEvents, setAdditionalSourcesEvents] = useState({});

	const container = React.createRef();
	const eventsWrapper = React.createRef();
	const allEvents = {
		'ws-tagging': [],
		...additionalSourcesEvents
	};

	const useSources = [
		'ws-tagging',
		...(cmsWebAsSource
			? ['cms-web', ...additionalSources]
			: additionalSources)
	];

	/* Separate ws-tagging and cms-web events */
	props.data.forEach(({ detail: { source, ...event } }) => {
		if (!allEvents[source]) allEvents[source] = [];
		allEvents[source].push(event);
	});

	/* Filter Events */
	const eventsToShow = {};
	const filterFuncs = {
		'is exactly': (k, v, e) => e[k] && e[k] === v,
		contains: (k, v, e) => e[k] && e[k].includes(v),
		'is not': (k, v, e) => !e[k] || e[k] !== v,
		'does not contain': (k, v, e) => !e[k] || !e[k].includes(v),
		'starts with': (k, v, e) => e[k] && e[k].startsWith(v),
		'ends with': (k, v, e) => e[k] && e[k].endsWith(v),
		'does not start with': (k, v, e) => !e[k] || !e[k].startsWith(v),
		'does not end with': (k, v, e) => !e[k] || !e[k].endsWith(v)
	};
	const passesAllFilters = (event) => {
		const flatEvent = flattenObject(event);
		return filters.every(({ key, condition, value }) => {
			return filterFuncs[condition](key, value, flatEvent);
		});
	};
	Object.keys(allEvents).forEach((source) => {
		if (useSources.indexOf(source) > -1) {
			eventsToShow[source] = [];
			allEvents[source].forEach((event) => {
				if (passesAllFilters(event)) {
					eventsToShow[source].push(event);
				}
			});
		}
	});
	const maxEvents = Math.max(
		...Object.keys(eventsToShow).map(
			(source) => eventsToShow[source].length
		)
	);

	/* Order */

	Object.keys(eventsToShow).forEach((source) => {
		eventsToShow[source].forEach((event, index) => {
			// eslint-disable-next-line no-param-reassign
			event.order = index + 1;
		});
		if (orderSetting === 'Oldest on top') {
			eventsToShow[source].reverse();
		}
	});

	/*
		Dragging
	*/
	let mouseStartPos;
	let containerStartPos;
	let containerStartSize;
	const dragMove = (event) => {
		const currentMousePos = {
			// Where is the mouse now
			x: event.screenX,
			y: event.screenY
		};
		const mousePosDiff = {
			// How far has it moved since the drag started
			x: mouseStartPos.x - currentMousePos.x,
			y: mouseStartPos.y - currentMousePos.y
		};
		const attemptPos = {
			// Where is the user trying to put the popup
			x: containerStartPos.x - mousePosDiff.x,
			y: containerStartPos.y - mousePosDiff.y
		};
		const newPos = {
			// Dont allow it to leave the page
			left: bound(
				attemptPos.x,
				16,
				window.innerWidth - containerStartSize.width - 16
			),
			top: bound(
				attemptPos.y,
				16,
				window.innerHeight - containerStartSize.height - 16
			)
		};
		// Set its new position
		if (container.current) {
			container.current.style.left = `${newPos.left}px`;
			container.current.style.top = `${newPos.top}px`;
		}
		return newPos;
	};
	const dragEnd = async (event) => {
		window.removeEventListener('mousemove', dragMove);
		window.removeEventListener('mouseup', dragEnd);
		const { top: finalTop, left: finalLeft } = dragMove(event); // set (and get) its final positon
		setSetting('top', finalTop);
		setSetting('left', finalLeft);
	};
	const dragStart = (event) => {
		mouseStartPos = {
			// Save the position of where the drag started, used to calculate the movement distance later
			x: event.screenX,
			y: event.screenY
		};
		containerStartPos = {
			// Save the starting position of the container, used to calculate its new position later
			x: left,
			y: top
		};
		const {
			// Get the current width and height of the popup
			// eslint-disable-next-line no-shadow
			width,
			// eslint-disable-next-line no-shadow
			height
		} = container.current.getBoundingClientRect();
		containerStartSize = {
			// save the width and height to later calculate if it is going off the screen
			width,
			height
		};
		window.addEventListener('mousemove', dragMove);
		window.addEventListener('mouseup', dragEnd);
	};

	useEffect(() => {
		// monitor usage of eventViewer fuctionality
		// if there is a huge spike in activity could be a bug in how it shows
		addNewRelicPageAction('ws-tagging-event-viewer');

		const unloadHandler = (event) => {
			if (promptUnload) {
				// The new way to cause a leave confirmation dialog
				event.preventDefault();
				// The old way to cause a leave confirmation dialog,
				//   the custom message is no longer supported but still causes dialog
				// eslint-disable-next-line no-param-reassign
				event.returnValue = 'Are you sure you want to leave?';
			}
		};

		window.addEventListener('beforeunload', unloadHandler);
		return function cleanup() {
			window.removeEventListener('beforeunload', unloadHandler);
		};
	});

	/*
		Resize 
	*/
	// eslint-disable-next-line no-shadow
	const onResize = debounce((width, height) => {
		setSetting('width', width);
		setSetting('height', height);
	}, 250);
	useEffect(() => {
		const resizeObserver = new ResizeObserver(() => {
			if (!fullscreen && eventsWrapper?.current) {
				const { width, height } =
					eventsWrapper.current.getBoundingClientRect();
				onResize(width, height);
			}
		});
		resizeObserver.observe(eventsWrapper.current);
	}, [eventsWrapper, onResize, fullscreen]);

	/*
		Watch Additional Sources
	*/
	useEffect(() => {
		const watcher = (source, array) => {
			const newASE = {
				...additionalSourcesEvents,
				[source]: array
			};
			setAdditionalSourcesEvents(newASE);
		};
		additionalSources.forEach((source) => watchArray(source, watcher));
		return function cleanup() {
			additionalSources.forEach((source) =>
				unwatchArray(source, watcher)
			);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [additionalSources]);

	const eventViewerClasses = [
		'ws-tagging-event-viewer',
		'position-fixed',
		'bg-white',
		'text-dark',
		'border',
		'rounded',
		'shadow-lg',
		'hide-from-ws-tracking'
	];
	if (!showing) eventViewerClasses.push('ws-tagging-event-viewer--hidden');
	if (fullscreen) eventViewerClasses.push('ws-tagging-ev-fullscreen');

	return ReactDOM.createPortal(
		<div
			ref={container}
			className={eventViewerClasses.join(' ')}
			style={{
				top,
				left
			}}
			data-testid="EventViewer"
		>
			<div className="ws-tagging-ev-header d-flex border-bottom bg-light">
				<button
					className="ws-tagging-show-hide btn btn-secondary"
					type="button"
					onClick={() => {
						setSetting('showing', !showing);
					}}
					aria-hidden="true"
				>
					{!showing ? 'Show' : 'Hide'}
				</button>
				<div
					className={[
						'ws-tagging-ev-title',
						'font-weight-bold',
						'ddc-font-size-large',
						'flex-fill',
						'd-flex',
						'align-items-center',
						'justify-content-center'
					].join(' ')}
					onMouseDown={dragStart}
					role="none"
				>
					Event Viewer
				</div>
				<button
					className="ws-tagging-ev-clear btn"
					onClick={props.clearEventViewer}
					type="button"
					aria-hidden="true"
				>
					Clear
				</button>
				<button
					className="ws-tagging-ev-show-settings btn border-left"
					onClick={() => setSettingsOpen(!settingsOpen)}
					type="button"
					aria-hidden="true"
				>
					<i className="ddc-icon ddc-icon-specs-gear1 ddc-icon-size-xlarge" />
				</button>
				<button
					className="ws-tagging-ev-fullscreen btn border-left"
					onClick={() => setSetting('fullscreen', !fullscreen)}
					type="button"
					aria-hidden="true"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 24 24"
						width="24px"
					>
						<path
							fill="currentColor"
							d={
								fullscreen
									? 'M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z'
									: 'M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z'
							}
						/>
					</svg>
				</button>
			</div>
			<Settings opened={settingsOpen} />
			<div
				className="ws-tagging-ev-events-wrapper mx-2"
				ref={eventsWrapper}
				style={{
					width,
					height
				}}
			>
				{useSources?.length > 1 && (
					<div
						className="ws-tagging-ev-events-source-titles"
						style={{
							gridTemplateColumns: `repeat(${useSources.length}, minmax(300px, 1fr))`
						}}
					>
						{useSources.map((source) => (
							<h5 className="ws-tagging-ev-events-souce-title border-bottom px-4 pb-2 mx-2">
								{source}
							</h5>
						))}
					</div>
				)}
				<div
					className="ws-tagging-ev-events-grid"
					style={{
						gridTemplateColumns: `repeat(${useSources.length}, minmax(300px, 1fr))`
					}}
				>
					{useSources.map((source, sourceIndex) => {
						if (!eventsToShow[source]) {
							return (
								<div
									className="p-4"
									style={{
										gridRow: 1,
										gridColumn: sourceIndex + 1
									}}
								>
									<h5>No Events Showing From Source</h5>
									<p className="mb-2">
										This may of occured because:
									</p>
									<ul>
										<li>The source does not exist</li>
										<li>
											The source does not have any events
											<ul>
												<li>
													You may have cleared all
													events from{' '}
													<code>ws-tagging</code>{' '}
													and/or
													<code>cms-web</code> by
													clicking the
													&quot;Clear&quot; button
													above.
												</li>
											</ul>
										</li>
										<li>
											Your filters have hidden all events
											from this source
										</li>
									</ul>
								</div>
							);
						} else {
							return eventsToShow[source].map(
								({ order, ...detail }, index) => {
									const { classes, diff, ...detailToShow } =
										detail;
									const key = `ws-tagging-ev-${index}`;
									return (
										<ViewEvent
											key={key}
											details={detailToShow}
											diff={diff}
											index={order}
											sourceIndex={sourceIndex}
											className={classes}
											source={source}
											row={
												orderSetting === 'Oldest on top'
													? order
													: maxEvents - index
											}
										/>
									);
								}
							);
						}
					})}
				</div>
			</div>
		</div>,
		document.getElementsByTagName('body')[0]
	);
}

EventViewer.propTypes = {
	data: PropTypes.arrayOf(PropTypes.shape)
};
